import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceCatalogServices } from '../services/service-catalog.service';

export const useAddServiceCatalog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => serviceCatalogServices.addServiceCatalog(payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['service-catalog']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to add service catalog entry');
    },
  });
};
